import React, { useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//Sections
import ChooseLocation from "./sections/ChooseLocation";
import ExpenseInfo from "./sections/ExpenseInfo";
import ExpiryDate from "./sections/ExpiryDate";
import ItemIngredients from "./sections/ItemIngredients";
import ProductBrand from "./sections/ProductBrand";
import PurchaseInfo from "./sections/PurchaseInfo";
import StoreInfo from "./sections/StoreInfo";

const AddIndividualItem = ({ pantry: { modals } }) => {
  return (
    <div className="w-full">
      {modals?.add?.stage === "location" && <ChooseLocation />}
      {modals?.add?.stage === "ingredients" && <ItemIngredients />}
      {modals?.add?.stage === "product" && <ProductBrand />}
      {modals?.add?.stage === "expiry" && <ExpiryDate />}
      {modals?.add?.stage === "purchase" && <PurchaseInfo />}
      {modals?.add?.stage === "store" && <StoreInfo />}
      {modals?.add?.stage === "expense" && <ExpenseInfo />}
    </div>
  );
};

AddIndividualItem.propTypes = {
  pantry: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  pantry: state.pantry,
});

export default connect(mapStateToProps)(AddIndividualItem);
